// Sync state of one promote-plan row. The promoter reports R2 status and,
// since it uploads binaries to OSS itself, OSS status per destination.
export type PromoteDestStatus = {
  key: string
  exists: boolean
  sizeMatches: boolean
  // Absent when an older promoter answers; then only R2 is known.
  ossExists?: boolean
  ossSizeMatches?: boolean
}

export type PlanEntryState = 'synced' | 'pending' | 'oss-pending'

export function planEntryState(destStatus: PromoteDestStatus[]): PlanEntryState {
  if (!destStatus.every((dest) => dest.sizeMatches)) return 'pending'
  if (!destStatus.every((dest) => dest.ossSizeMatches !== false)) return 'oss-pending'
  return 'synced'
}
